import { render, staticRenderFns } from "./ticketModalItemList.vue?vue&type=template&id=fa639be0&scoped=true&"
import script from "./ticketModalItemList.vue?vue&type=script&lang=js&"
export * from "./ticketModalItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa639be0",
  null
  
)

export default component.exports